(function () {
    'use strict';

    angular
        .module('app')
        .component('webListAdmin', {
            templateUrl: 'app/components/web/admin/web/web-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, Web, WebUtil, RutasService, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Web;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {titulo: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Web) {
                            return Web.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'web.web.admin.delete.title',
                                body: 'web.web.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };

        vm.rutaBase = RutasService.getBaseUrl() + WebUtil.getRutaWebPublica();
    }

})();
